var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.platformIsNotSupported)?[_c('not-support',{attrs:{"platformIsMobile":_vm.platformIsMobile,"platformName":_vm.platformName}})]:[_c('router-view'),_c('notification-item'),_c('connection-error-popup',{attrs:{"showPopup":_vm.showPopup}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }